/* ============================================================
   Section: Rich Text Animated
   IntersectionObserver entrance, scramble, typewriter, hover
   ============================================================ */

(function () {
  'use strict';

  var SCRAMBLE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%&*?';

  function initSection(section) {
    if (!section || section.dataset.rtaInitialized) return;
    section.dataset.rtaInitialized = 'true';

    /* ── Observe each heading ── */
    var headings = section.querySelectorAll('.rta-heading');
    var faders   = section.querySelectorAll('.rta-fade-in');

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;

        if (el.classList.contains('rta-heading')) {
          animateHeading(el);
        } else {
          el.classList.add('is-visible');
        }

        io.unobserve(el);
      });
    }, { threshold: 0.15 });

    headings.forEach(function (h) { io.observe(h); });
    faders.forEach(function (f) { io.observe(f); });


    /* ── Route animation ── */
    function animateHeading(el) {
      var style = '';
      var classList = el.className.split(' ');
      for (var i = 0; i < classList.length; i++) {
        if (classList[i].indexOf('rta-heading--') === 0) {
          style = classList[i].replace('rta-heading--', '');
          break;
        }
      }
      if (!style) style = 'wave';

      // Apply gradient to heading element directly for CSS bg-clip
      var textStyle = '';
      for (var j = 0; j < classList.length; j++) {
        if (classList[j].indexOf('rta-style--') === 0) {
          textStyle = classList[j].replace('rta-style--', '');
          break;
        }
      }

      if (textStyle === 'gradient-linear' || textStyle === 'gradient-radial') {
        el.querySelectorAll('.rta-char').forEach(function (c) {
          c.style.setProperty('-webkit-text-fill-color', 'transparent');
          c.style.setProperty('color', 'transparent');
        });
      }

      if (style === 'scramble') {
        runScramble(el);
      } else if (style === 'typewriter') {
        runTypewriter(el);
      } else if (style === 'morph-weight') {
        applyTwoToneIfNeeded(el, textStyle);
        el.classList.add('is-visible');
      } else {
        applyTwoToneIfNeeded(el, textStyle);
        el.classList.add('is-visible');
      }
    }


    /* ── Two-tone: wrap word groups ── */
    function applyTwoToneIfNeeded(el, textStyle) {
      if (textStyle !== 'two-tone') return;
      var chars = el.querySelectorAll('.rta-char');
      var wordIndex = 0;
      var inSpace = true;

      chars.forEach(function (c) {
        if (c.classList.contains('rta-space')) {
          inSpace = true;
          return;
        }
        if (inSpace) { wordIndex++; inSpace = false; }
        c.style.color = wordIndex % 2 === 0
          ? 'var(--rta-color-1)'
          : 'var(--rta-color-2)';
      });
    }


    /* ── Typewriter ── */
    function runTypewriter(el) {
      var chars = el.querySelectorAll('.rta-char');
      var stagger = parseInt(getComputedStyle(el).getPropertyValue('--rta-stagger')) || 50;

      chars.forEach(function (c, i) {
        setTimeout(function () {
          c.style.opacity = '1';
          if (i === chars.length - 1) {
            setTimeout(function () { el.classList.add('typing-done'); }, stagger * 8);
          }
        }, i * stagger * 0.6);
      });

      el.classList.add('is-running');
    }


    /* ── Scramble ── */
    function runScramble(el) {
      var chars    = Array.from(el.querySelectorAll('.rta-char'));
      var origText = chars.map(function (c) { return c.dataset.char || c.textContent; });
      var stagger  = parseInt(getComputedStyle(el).getPropertyValue('--rta-stagger')) || 40;
      var duration = parseInt(getComputedStyle(el).getPropertyValue('--rta-duration')) || 600;

      el.classList.add('is-running');

      chars.forEach(function (charEl, i) {
        if (charEl.classList.contains('rta-space')) {
          charEl.style.opacity = '1';
          return;
        }

        var delay    = i * stagger * 0.5;
        var resolveAt = delay + duration * 0.6;
        var startedAt = performance.now();
        var resolved = false;

        charEl.style.opacity = '1';

        function tick(now) {
          var elapsed = now - startedAt - delay;
          if (elapsed < 0) { requestAnimationFrame(tick); return; }

          if (elapsed >= resolveAt - delay && !resolved) {
            charEl.textContent = origText[i];
            resolved = true;
            return;
          }

          if (!resolved) {
            charEl.textContent = SCRAMBLE_CHARS[
              Math.floor(Math.random() * SCRAMBLE_CHARS.length)
            ];
            requestAnimationFrame(tick);
          }
        }

        requestAnimationFrame(tick);
      });
    }


    /* ── Hover interactions ── */
    var hoverStyle = section.dataset.hover;

    if (hoverStyle === 'magnetic') {
      section.querySelectorAll('.rta-heading').forEach(function (heading) {
        heading.addEventListener('mousemove', function (e) {
          var chars = heading.querySelectorAll('.rta-char');
          chars.forEach(function (c) {
            var rect = c.getBoundingClientRect();
            var cx = rect.left + rect.width / 2;
            var cy = rect.top + rect.height / 2;
            var dx = e.clientX - cx;
            var dy = e.clientY - cy;
            var dist = Math.sqrt(dx * dx + dy * dy);
            var maxDist = 100;
            if (dist < maxDist) {
              var force = (maxDist - dist) / maxDist;
              c.style.transform = 'translate(' + (dx * force * 0.3) + 'px, ' + (dy * force * 0.3) + 'px)';
            } else {
              c.style.transform = '';
            }
          });
        });

        heading.addEventListener('mouseleave', function () {
          heading.querySelectorAll('.rta-char').forEach(function (c) {
            c.style.transform = '';
          });
        });
      });
    }
  }

  /* ─── Auto-init on page load ─── */
  function initAll() {
    document.querySelectorAll('.rta-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* ─── Shopify theme editor support ─── */
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.rta-section');
    if (section) {
      section.removeAttribute('data-rta-initialized');
      initSection(section);
    }
  });
})();
